import { chakra, Flex, HStack, Image, Stack, Text } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import { dashboardTokens } from '../dashboardTokens';

/**
 * (3134/3135) Services the company could still add, each with "+ Add now",
 * which opens Add New Service with that service's confirmation.
 *
 * @param {object} props
 * @param {{ profile: object, name: string, icon?: string }[]} props.services
 * @param {(profile: object) => void} props.onAddNow
 */
const AvailableServices = ({ services, onAddNow }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const tokens = dashboardTokens(darkMode);

    return (
        <Stack spacing={1.5} mt={3} aria-label="Services available to add">
            {services.map(({ profile, name, icon }) => (
                <Flex
                    key={profile.id}
                    align="center"
                    justify="space-between"
                    gap={3}
                    borderRadius="lg"
                    px={3}
                    py={2}
                    bg={tokens.availableRow.bg}>
                    <HStack spacing={2} minW={0}>
                        {icon && (
                            <Image
                                src={icon}
                                alt=""
                                boxSize="20px"
                                objectFit="contain"
                                flexShrink={0}
                            />
                        )}
                        <Text
                            fontSize="xs"
                            fontWeight="medium"
                            color={tokens.muted}
                            noOfLines={1}>
                            {name}
                        </Text>
                    </HStack>
                    <chakra.button
                        type="button"
                        onClick={() => onAddNow(profile)}
                        aria-label={`Add ${name}`}
                        flexShrink={0}
                        minW="100px"
                        px={2}
                        py={0.5}
                        fontSize="11px"
                        fontWeight="semibold"
                        borderRadius="full"
                        borderWidth="1px"
                        borderColor={tokens.addService.color}
                        color={tokens.addService.color}
                        bg={tokens.availableRow.addNowBg}
                        _hover={{ boxShadow: 'sm' }}
                        _focusVisible={{ boxShadow: 'outline' }}>
                        + Add now
                    </chakra.button>
                </Flex>
            ))}
        </Stack>
    );
};

export default AvailableServices;
